import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bb9bfbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statement" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-title" }, "说明", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc-content" }, [
  /*#__PURE__*/_createTextVNode(" 由于跨境支付需要审核，部分项款到账存在延时，最晚24小时内到账。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("汇率按以当日银行提供汇率为准。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("label", { class: "tips" }, " *支付金额为美金,财务会根据银行提供的当日汇率换算成人民币并充值到格布小包余额。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("label", { class: "tips" }, "*请注意,这笔收款人在您的信用卡账单上会显示为\"SOTO LIFESTYLE\"。")
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}